import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FiscalMode, FiscalService } from '../../services/fiscal.service';

/** NF525 §7: a training ticket must be impossible to mistake for a real one.
 *  The paper already carries the notice; the screen has to say it too, or the
 *  operator never learns which reality they are keying into. */
@Component({
  selector: 'app-training-mode-banner',
  imports: [CommonModule, NzIconModule],
  templateUrl: './training-mode-banner.component.html',
  styleUrls: ['./training-mode-banner.component.scss'],
})
export class TrainingModeBannerComponent {
  private readonly fiscalService = inject(FiscalService);

  readonly mode = this.fiscalService.mode;
  readonly FiscalMode = FiscalMode;
}
